export const ELDERS_URL = "http://ents.tokents.org";
export const ELDER_CODE_PREFIX = "GKHH";
export const ELDER_CODE_TRAIT = "Elder ENT code";
export const OPENSEA_TESTNET_URL = "https://testnets.opensea.io";
export const OPENSEA_URL = "https://opensea.io";
export const RED_MARKER = '/img/maps/marker-red.svg';
export const GREEN_MARKER = '/img/maps/marker-tree.svg';
